<template lang="html">
  <div class="cookie-list">
    <template v-for="cookie in cookieData">
      <div class="row cookie-details">
        <div class="col-3 service-name"><strong>Service:</strong></div>
        <div class="col-9 service-name"><strong>{{ cookie.serviceName }}</strong></div>

        <div class="col-3"><strong>Formål:</strong></div>
        <div class="col-9">{{ cookie.purpose }}</div>

        <div class="col-3" v-show="cookie.privacyPolitics != false"><strong>Privatlivspolitik:</strong></div>
        <div class="col-9" v-show="cookie.privacyPolitics != false" v-html="cookie.privacyPolitics"></div>

        <div class="col-3"><strong>Udløb:</strong></div>
        <div class="col-9">{{ cookie.expirationDate }}</div>

        <div class="col-3"><strong>Navn:</strong></div>
        <div class="col-9">{{ cookie.cookieName }}</div>

        <div class="col-3"><strong>Udbyder:</strong></div>
        <div class="col-9">{{ cookie.providerName }}</div>
      </div>
    </template>
  </div>

</template>

<script>
export default {
  props: {
    cookieData: {
      required: true,
    }
  },
  created() {
    //console.log(this.cookieData);
  }
}
</script>

<style lang="css" scoped>
  .cookie-details {
    margin-top: 20px;
    font-size: 13px;
  }

  .cookie-details:last-child {
    margin-bottom: 20px;
  }

  .service-name {
    font-size: 15px;
  }
</style>
